(() => {
  const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const filename = url => new URL(url, 'https://sjbjjapparel.com').pathname.split('/').pop();
  window.sjbjjResolveMedia = data => {
    if (!data || !Array.isArray(data.images) || !Array.isArray(data.colors)) return null;
    const images = data.images;
    const byId = new Map(images.map(image => [String(image.id), image]));
    const named = new Map();
    const labeled = new Map();
    let hasLabels = false;
    images.forEach(image => {
      const match = filename(image.url).match(/^(.*)-(front|back)-[^/]+\.(?:jpe?g|png|webp|avif)$/i);
      if (match) {
        const pair = named.get(match[1]) || {};
        pair[match[2].toLowerCase()] = image;
        named.set(match[1], pair);
      }
      const label = String(image.alt || '').match(/^(.+?)\s*[|—]\s*(front|back)$/i);
      if (label) {
        hasLabels = true;
        const key = normalize(label[1]);
        const pair = labeled.get(key) || {};
        const side = label[2].toLowerCase();
        if (pair[side]) pair.ambiguous = true;
        pair[side] = image;
        labeled.set(key, pair);
      }
    });
    const colors = data.colors.length ? data.colors : [{ color: '', front: images[0]?.id }];
    const fronts = new Set(colors.map(color => String(color.front)));
    const count = colors.length;
    const complete = images.length === data.total && fronts.size === count && colors.every(color => byId.has(String(color.front)));
    const blocked = complete && images.length === count * 2 && images.slice(0, count).every(image => fronts.has(String(image.id)));
    const alternating = complete && images.length === count * 2 && images.every((image, index) => fronts.has(String(image.id)) === (index % 2 === 0));
    const infer = data.printify && !hasLabels && (blocked || alternating);
    const groups = colors.map(color => {
      let front = byId.get(String(color.front));
      let back;
      const label = labeled.get(normalize(color.color));
      if (label && !label.ambiguous) {
        front = label.front || front;
        back = label.back;
      }
      if (front && !back) {
        for (const pair of named.values()) {
          if (pair.front?.id === front.id) { back = pair.back; break; }
        }
      }
      if (front && !back && infer) {
        const index = images.indexOf(front);
        back = images[index + (blocked ? count : 1)];
      }
      if (!front || (back && (back.id === front.id || (fronts.has(String(back.id)) && back.id !== color.front)))) return null;
      return { color: color.color, front: String(front.id), ids: [front, back].filter(Boolean).map(image => String(image.id)) };
    }).filter(Boolean);
    const used = groups.flatMap(group => group.ids);
    if (!groups.length || new Set(used).size !== used.length) return null;
    return { option: data.option, position: data.position, groups };
  };
})();
